// extracted by mini-css-extract-plugin
export default {"numText":"styles_numText__RmWFn","container":"styles_container__OAFJx","iconWrapper":"styles_iconWrapper__SPb7I"};